import * as React from 'react';
import cn from 'classnames';

import { Banner } from '../Banner';
import { Button } from '@cian/ui-kit';
import { useIsMobileDevice } from '../../../../hooks';
import { useCreateMessage } from '../../hooks/useCreateMessage';

import realtorDesktop from './images/realtor-desktop.png';
import realtorMobile from './images/realtor-mobile.svg';
import check from '../../../../assets/check.svg';

import {
  TEXT_BUTTON_DESKTOP,
  TEXT_BUTTON_MOBILE,
  TEXT_DESKTOP,
  TEXT_MOBILE,
  TITLE_DESKTOP,
  TITLE_MOBILE,
} from './constants';

import * as styles from './styles.css';

/**
 * Контейнер, где формируется баннер для add-form.jade
 */
interface IDemandTrapBannerProps {
  dealType: string;
}

export const DemandTrapBanner: React.FC<IDemandTrapBannerProps> = ({ dealType }) => {
  const isMobile = useIsMobileDevice();
  const [{ isLoading, isSuccess, isError }, executeCreateMessage] = useCreateMessage(dealType);

  const title = isMobile ? TITLE_MOBILE : TITLE_DESKTOP;
  const text = isMobile ? TEXT_MOBILE : TEXT_DESKTOP;
  const textButton = isMobile ? TEXT_BUTTON_MOBILE : TEXT_BUTTON_DESKTOP;

  const sizeButton = isMobile ? 'M' : 'XS';
  const srcImage = isMobile ? realtorMobile : realtorDesktop;
  const stylesForImg = isMobile ? styles['image-mobile'] : styles['image-desktop'];

  return (
    <Banner
      title={title}
      text={text}
      button={
        isSuccess ? (
          <div className={styles['success']}>
            <img alt="" src={check} />
            <span className={styles['success-text']}>Заявка отправлена</span>
          </div>
        ) : (
          <>
            <Button onClick={executeCreateMessage} size={sizeButton} loading={isLoading}>
              {textButton}
            </Button>
            {isError && (
              <p className={cn(styles['error-text'], isMobile && styles['error-text-mobile'])}>
                Случилась ошибка. Попробуйте снова
              </p>
            )}
          </>
        )
      }
      image={<img className={stylesForImg} alt="риелтор" src={srcImage} />}
      hasGradientBorder
    />
  );
};
